import { Injectable } from '@angular/core';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { AccountingAccountPageInterface } from '@zaoblako/shared/modules/catalog/dtos/accounting-account/accounting-account-page.dto';
import type { AccountingAccountQueryInterface } from '@zaoblako/shared/modules/catalog/dtos/accounting-account/accounting-account-query.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BasisAccountingAccountService extends BaseService {
  public baseUrl = '/basis/catalog/accounting-account';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findWithPagination(
    queryParams: AccountingAccountQueryInterface
  ): Observable<AccountingAccountPageInterface> {
    return this.http.get<AccountingAccountPageInterface>(`${this.baseUrl}/items`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public synchronize(): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/synchronize`, null);
  }
}
